export default __webpack_public_path__ + "static/media/Motilal Building.10c75aaf.svg";